import React, { useState } from "react";
import {
  View,
  Text,
  ScrollView,
  Pressable,
  TextInput,
  ActivityIndicator,
  Image,
} from "react-native";
import { useAuth } from "../../context/Auth/AuthContext";
import useRequestApprovals from "../../hooks/Request/useRequestApprovals";
import { format } from "date-fns";
import ScreenContainer from "../../components/Containers/ScreenContainer";
import { getTypeStyle } from "../../utils/typeStyle";
import Notification from "../../components/Notification/Notification";

const TABS: any[] = ["User", "Time"];

const RequestEntryApprovalScreen = () => {
  const {
    groupedEntries,
    handleApprove,
    handleDeny,
    loading,
    groupBy,
    setGroupBy,
    searchTerm,
    setSearchTerm,
    errorNotification,
    dismissNotification,
    reloadRequests,
  } = useRequestApprovals();

  return (
    <ScreenContainer>
      <View className="bg-white min-h-full px-4 pt-6 pb-8">
        <Text className="text-2xl font-bold text-[#91c341] text-center mb-4">
          Entry Request Manager
        </Text>
        <Text className="text-base text-center text-gray-600 mb-6">
          Manage submitted time entry change requests below.
        </Text>

        {/* Tabs */}
        <View className="flex-row justify-center gap-2 mb-4">
          {TABS.map((tab) => (
            <Pressable
              key={tab}
              onPress={() => setGroupBy(tab)}
              className={`px-4 py-2 rounded-full border ${
                groupBy === tab
                  ? "bg-blue-600 border-blue-600"
                  : "bg-white border-gray-300"
              }`}
            >
              <Text
                className={`font-medium capitalize ${
                  groupBy === tab ? "text-white" : "text-gray-700"
                }`}
              >
                Group by {tab}
              </Text>
            </Pressable>
          ))}
        </View>

        {/* Loading */}
        {loading ? (
          <ActivityIndicator size="large" className="mt-10" />
        ) : (
          <ScrollView>
            {groupedEntries.length === 0 ? (
              <Text className="text-center text-gray-500 mt-10">
                No {groupBy.toLowerCase()} requests found.
              </Text>
            ) : (
              groupedEntries.map((group, i) => (
                <View key={i} className="mb-6">
                  <Text className="font-bold text-lg text-gray-800 mb-3">
                    {group.group}
                  </Text>

                  {group.entries.map((req: any) => (
                    <View
                      key={req.id}
                      className="bg-white border border-gray-200 shadow-sm rounded-xl px-4 py-3 mb-4"
                    >
                      <View className="flex-row items-center mb-3">
                        {/* <Image source={require("../assets/images/logo_default.png")} className="h-16 w-48" resizeMode="contain" /> */}
                        <Image
                          source={{ uri: req.photo }}
                          className="w-10 h-10 rounded-full mr-3"
                        />
                        <View>
                          <Text className="text-base font-semibold text-blue-700">
                            {format(
                              new Date(req.time),
                              "EEEE, MMM d - hh:mm a"
                            )}
                          </Text>
                          <Text className="text-sm text-gray-500">
                            {req.userName}
                          </Text>
                        </View>
                      </View>

                      <View className="flex-row items-center gap-2 mb-1">
                        <Text className="font-semibold text-gray-700">
                          Type:
                        </Text>
                        <Text
                          className={`text-sm px-2 py-1 rounded-full font-medium ${getTypeStyle(
                            req.type
                          )}`}
                        >
                          {req.type.replace(/([a-z])([A-Z])/g, "$1 $2")}
                        </Text>
                      </View>

                      {req.comment ? (
                        <Text className="text-gray-600 italic text-sm mb-2">
                          “{req.comment}”
                        </Text>
                      ) : null}

                      <View className="flex-row justify-end gap-2 mt-3">
                        <Pressable
                          onPress={async () => {
                            await handleApprove(req.id);
                            await reloadRequests(); // ✅ recarga la lista
                          }}
                          className="px-4 py-2 rounded-md bg-green-500"
                        >
                          <Text className="text-white font-medium">
                            Approve
                          </Text>
                        </Pressable>

                        <Pressable
                          onPress={async () => {
                            await handleDeny(req.id);
                            await reloadRequests(); // ✅ recarga la lista
                          }}
                          className="px-4 py-2 rounded-md bg-red-500"
                        >
                          <Text className="text-white font-medium">Deny</Text>
                        </Pressable>
                      </View>
                    </View>
                  ))}
                </View>
              ))
            )}
          </ScrollView>
        )}
      </View>
      {errorNotification && (
        <Notification
          title="Notification!"
          message={errorNotification}
          type="info"
          actions={
            <button
              onClick={dismissNotification}
              className="text-sm font-medium text-white bg-red-600 px-3 py-1 rounded hover:bg-red-700"
            >
              Close
            </button>
          }
        />
      )}
    </ScreenContainer>
  );
};

export default RequestEntryApprovalScreen;
